'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _location_service = require('../services/location_service.js');

var _location_service2 = _interopRequireDefault(_location_service);

var _click_or_escape_outside = require('./click_or_escape_outside.js');

var _click_or_escape_outside2 = _interopRequireDefault(_click_or_escape_outside);

var _dropdown_component = require('./global_components/dropdown_component.js');

var _dropdown_component2 = _interopRequireDefault(_dropdown_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _tracking_utility = require('common-utilities/src/tracking_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShareclassSelector = function (_React$PureComponent) {
  _inherits(ShareclassSelector, _React$PureComponent);

  function ShareclassSelector(props) {
    _classCallCheck(this, ShareclassSelector);

    var _this = _possibleConstructorReturn(this, (ShareclassSelector.__proto__ || Object.getPrototypeOf(ShareclassSelector)).call(this, props));

    _this.state = {
      processingEscape: false
    };

    _this.shareClassSelectorItems = _this.shareClassSelectorItems.bind(_this);
    _this.focusNextShareclassItem = _this.focusNextShareclassItem.bind(_this);
    _this.onChangeEvent = _this.onChangeEvent.bind(_this);
    _this.onClose = _this.onClose.bind(_this);
    return _this;
  }

  _createClass(ShareclassSelector, [{
    key: 'shareClassSelectorItems',
    value: function shareClassSelectorItems() {
      var _this2 = this;

      if (!this.props.options) {
        return null;
      }

      var shareclassNameAttribute = "shareclassName";
      var lowerCaseCuip = (0, _ramda.toLower)(this.props.cusip);

      var filteredOptions = this.props.options.filter(function (o) {
        return (0, _ramda.toLower)(o.cusip) !== lowerCaseCuip;
      });
      var lastCusip = filteredOptions[filteredOptions.length - 1] ? filteredOptions[filteredOptions.length - 1].cusip : "";

      return filteredOptions.map(function (item) {
        _this2[item.cusip + 'shareclassDropdown'] = _react2.default.createRef();
        var onFocusProp = lastCusip === item.cusip ? {
          onFocus: function onFocus() {
            var shareclassSelectorId = '#' + (_this2.props.isStickyHeaderVisible ? "sticky-" : "") + 'shareclass-selector';
            if (!_this2.state.processingEscape && (0, _ramda.indexOf)("clicked", document.querySelector(shareclassSelectorId + " .dropdown-display-header").classList) === -1) {
              document.querySelector(shareclassSelectorId + " .npe-icon-down-arrow-white").click();
            }

            _this2.setState({ processingEscape: false });
          }
        } : {};
        return _react2.default.createElement(
          'div',
          _extends({}, onFocusProp, {
            tabIndex: '-1',
            ref: _this2[item.cusip + 'shareclassDropdown'],
            key: item.cusip,
            'data-cusip': item.cusip,
            'data-category-code': item.categoryCode,
            'data-shareclass-name': item[shareclassNameAttribute],
            className: 'dropdown-list-item font-black',
            'data-testid': 'dropdown-on-change',
            onClick: _this2.onChangeEvent,
            role: 'option',
            onKeyDown: function onKeyDown(e) {

              if (e.key !== "Tab") {
                e.preventDefault();
              }
              if (e.key === "Tab") {
                var shareclassSelectorId = '#' + (_this2.props.isStickyHeaderVisible ? "sticky-" : "") + 'shareclass-selector';
                if ((0, _ramda.indexOf)("clicked", document.querySelector(shareclassSelectorId + " .dropdown-display-header").classList) === 1) {
                  document.querySelector(shareclassSelectorId + " .icon-up-arrow-white").click();
                }
              }

              if (e.key === "Enter") {
                _this2.onChangeEvent(e);
              }

              if (e.key === "ArrowDown") {
                if ((0, _ramda.isNil)(_this2[item.cusip + 'shareclassDropdown'].current.nextElementSibling)) {
                  _this2.focusShareclassItemForReference(filteredOptions[0].cusip + 'shareclassDropdown');
                } else {
                  _this2.focusNextShareclassItem(item.cusip + 'shareclassDropdown');
                }
              }

              if (e.key === "ArrowUp") {
                if ((0, _ramda.isNil)(_this2[item.cusip + 'shareclassDropdown'].current.previousElementSibling)) {
                  _this2.focusShareclassItemForReference(filteredOptions[0].cusip + 'shareclassDropdown');
                } else {
                  _this2.focusPreviousShareclassItem(item.cusip + 'shareclassDropdown');
                }
              }
            }
          }),
          _react2.default.createElement(
            'span',
            { 'data-cusip': item.cusip, 'data-category-code': item.categoryCode,
              'data-shareclass-name': item[shareclassNameAttribute],
              className: 'disclaimer' },
            item.displayName
          )
        );
      });
    }
  }, {
    key: 'focusShareclassItemForReference',
    value: function focusShareclassItemForReference(refString) {
      this[refString].current.focus();
    }
  }, {
    key: 'focusNextShareclassItem',
    value: function focusNextShareclassItem(refString) {
      this[refString].current.nextElementSibling.focus();
    }
  }, {
    key: 'focusPreviousShareclassItem',
    value: function focusPreviousShareclassItem(refString) {
      this[refString].current.previousElementSibling.focus();
    }
  }, {
    key: 'onChangeEvent',
    value: function onChangeEvent(e) {
      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": 'pdp',
        "eventAction": 'shareclass dropdown',
        "eventLabel": e.target.getAttribute("data-shareclass-name")
      });

      var retainTab = _collection_utility.CollectionUtility.includes(this.props.visibleData, "PDP_RETAIN_TAB");
      if (this.props.parent === 'aem') {
        _location_service2.default.setAEMNewLocation(e.target.getAttribute("data-cusip"), e.target.getAttribute("data-shareclass-name"), retainTab);
      } else {
        _location_service2.default.setNewLocation(e.target.getAttribute("data-cusip"), e.target.getAttribute("data-shareclass-name"), this.props.basePath, retainTab);
      }
    }
  }, {
    key: 'onClose',
    value: function onClose(e) {
      var _this3 = this;

      if (!(0, _ramda.isNil)(e) && e.code === 'Escape') {
        var lowerCaseCuip = (0, _ramda.toLower)(this.props.cusip);
        var filteredOptions = this.props.options.filter(function (o) {
          return (0, _ramda.toLower)(o.cusip) !== lowerCaseCuip;
        });
        this.setState({ processingEscape: true }, function () {
          _this3.focusShareclassItemForReference(filteredOptions[filteredOptions.length - 1].cusip + 'shareclassDropdown', null);
          e.preventDefault();
        });
        this.childRef.focus();
      }
    }
  }, {
    key: 'calculateDropdownWidth',
    value: function calculateDropdownWidth() {
      var maxLength = this.props.options.slice(0).sort(function (a, b) {
        return b.displayName.length - a.displayName.length;
      })[0].displayName.length * 10;

      return Math.max(250, maxLength) + "px";
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        _click_or_escape_outside2.default,
        {
          id: 'dropdownShareclass',
          additionalClassName: 'shareclass-dropdown display-inline-block ' + _functional_utility2.default.ifMobileBreakpoint(this.props.breakpoint, "col-xs-12", ""),
          onClose: this.onClose
        },
        _react2.default.createElement(_dropdown_component2.default, {
          dropdownContent: this.shareClassSelectorItems(),
          dropdownWidth: this.calculateDropdownWidth(),
          id: (this.props.isStickyHeaderVisible ? "sticky-" : "") + 'shareclass-selector',
          className: 'print-hide',
          breakpoint: this.props.breakpoint,
          initialActiveSelect: this.props.shareClassDisplayName,
          alwaysOpenOnSelect: false,
          dataTest: 'share-class-selector-dropdown',
          isShareClassDropDown: true,
          isHeader: true,
          ariaLabel: 'Select ShareClass',
          setRefDropdown: function setRefDropdown(node) {
            return _this4.childRef = node;
          }
        })
      );
    }
  }]);

  return ShareclassSelector;
}(_react2.default.PureComponent);

exports.default = ShareclassSelector;